import React, { Component } from 'react';
import { connect } from 'react-redux';
import  OfficeSetupMember  from '../../../components/UI/Member/OfficeSetupMember';
import { Label, Input, Button,Alert , Popover, PopoverHeader, PopoverBody,Breadcrumb, BreadcrumbItem } from 'reactstrap';
import Tooltip from '../../../components/UI/TooltipIcon/TooptipIcon';
import ErrorMessage from '../../../components/Message/ErrorMessage/ErrorMessage';
import { deepClone } from '../../../utils/copyObject';
import findIndex from 'lodash/findIndex';
import find from 'lodash/find';
import filter from 'lodash/filter';
import axios from '../../../axios';
import {roleOptions} from '../../../utils/constants';
import * as url from '../../../utils/url';
import addIcon from '../../../assets/plus.svg';
import { validateEmail } from '../../../utils/validations';
// import Loading from '../../../hoc/Loading/LoadingWithError';
import Loading from '../../../hoc/Loading/Loading';

import './InviteOfficeMates.css';

class InviteOfficeMates extends Component {

  constructor(props) {
    super(props);
    this.state = {
      shownMembersCount: 3,
      members: [],
      error: false,
      errorMessage: '',
      toggleRoleOpen:false,
      success:false,
      successMessage:'',
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  handleAddMember = () => {
    const { shownMembersCount } = this.state;
    this.setState({ shownMembersCount: shownMembersCount + 1 });
  }

  handleMemberDetailsAdded = (id, data) => {
    const { name, value } = data;
    const { members } = this.state;
    let specialChar = /[~`!#$%\^&*+=\\[\]\\';,/{}|\\":<>\?0-9]/g
    let specialCount=0
    // console.log(members)
    console.log(name, value, members)
    let index = findIndex(members, { id: id });
    if (index > -1) {
      // console.log(members[index][name])
      members[index][name] = value;
    } else {
      members.push({ id: id, [name]: value, role: data.name === 'role' ? data.value : 'Member' });
    }
    this.setState({ members: members });
  }

  populateAddMemberInputs = () => {
    let inputs = [];
    const { members } = this.state;
    console.log(this.props)
    for (let i = 0; i < this.state.shownMembersCount; i++) {
      inputs.push(<OfficeSetupMember memberData={find(members, { id: i })} id={i} key={i}
        onInputChange={this.handleMemberDetailsAdded} {...this.props}/>);
    }
    return inputs;
  }

  showErrorMsg=(error,message)=>{
    console.log('inside function showmsg')
    if (error && message) {
      let errorString = error.join(", ");

      if (message.includes("Invalid email Id") && message !== undefined) {
        console.log('msg')
        // this.setState({ error: true, errorMessage: errorString.replace(/,/g, ', ') + ' ' + 'Please enter a valid email.' });
        this.setState({ error: true, errorMessage:'Please enter a valid email.' });

      } else {
        console.log('err----')
        if(error.length===1){
          this.setState({ error: true, errorMessage: errorString + ' ' + ' is already registered. Please try a different one.' });
        } else {
          console.log('miltipls---')
          this.setState({ error: true, errorMessage: errorString + ' ' + ' are already registered. Please try different ones.' });
        }
      }
    } else {
      this.setState({ error: true, errorMessage: 'Failed to add invite members.' });
    }
  }

  handleSendInvite = () => {
    let specialChar = /[~`!#$%\^&*+=\\[\]\\';,/{}|\\":<>\?0-9]/g
    // let specialCount=0
    this.setState({success:false,error:false})
    let members = Array.from(this.state.members);
    members = deepClone(members);
    let membersFiltered = members.filter( el => el.email!="")
    console.log(membersFiltered)
    const invalidMembers = filter(membersFiltered, (member) => {
      if (member.email === undefined || specialChar.test(member.firstName) || specialChar.test(member.lastName)) {
        if (member.role === 'Admin') {
          return true;
        }
        return member
      }
      return false;
    })
    if (membersFiltered.length === 0) {
      this.setState({ error: true, errorMessage: 'Please enter details to invite members. Emails are required.' });
      return;
    }
    console.log(invalidMembers)
    
    if (invalidMembers.length > 0) {
      window.scroll(0, 0);
      this.setState({
        error: true,
        errorMessage: 'Please enter a valid email, first and last name without any special characters.'
      });
      return;
    } else {
      this.setState({
        error: false
      })
    }
    // let missingDetails = membersFiltered.filter(member => {
    //   console.log(member)
    //   if(member.firstName=="" && member.lastName=="" && member.email!=""){
    //     return member
    //   } 
    // });
    // if (missingDetails.length === 0) {
    //   this.setState({ error: true, errorMessage: 'Please enter emails to invite members.' });
    //   return;
    // }
    

    const payload = { data: membersFiltered };
    axios.post(url.addMembers, payload).then((response) => {
      console.log(response)
      if (response && response.length!=0 && response!==undefined && response.data && response.data !== undefined) {
        let {data} = response.data
        let stateUpdate= {
          success:true,
          successMessage: data.successRes.length>1? data.successRes.map(el=> el.email).join(', ') + ` were successfully invited`: data.successRes[0].email + ' was successfully invited.',
          members:[]
        }

        let error = data && data.errorRes && data.errorRes.length>0 ?true:false
       
        if(error){
          stateUpdate.error=error
          stateUpdate.errorMessage = data.errorRes.length>1? 
                                data.errorRes.join(', ') + ' are already registered. Please try different emails.':
                                data.errorRes + ' is already registered. Please try a different one.'
        }
        console.log(stateUpdate)
        this.setState( stateUpdate )
      }
    }).catch( err => {
   
      let{error, message}= err && err.response && err.response.data && err.response.data.errors
      ? err.response.data.errors
      : { error: null, message: null };
        // this.showErrorMsg(error, message)
        console.log(error, message)
        if (error && message) {
          let errorString = Array.isArray(error)?error.join(", "): error
    
          if (message.includes("Invalid email Id") && message !== undefined) {
            console.log('msg')
            // this.setState({ error: true, errorMessage: errorString.replace(/,/g, ', ') + ' ' + 'Please enter a valid email.' });
            this.setState({ error: true, errorMessage:'Please enter a valid email.' });
    
          } else {
            console.log('err----')
            if(error.length===1){
              this.setState({ error: true, errorMessage: errorString + ' ' + ' is already registered. Please try a different one.' });
            } else {
              console.log('miltipls---')
              this.setState({ error: true, errorMessage: errorString + ' ' + ' are already registered. Please try different ones.' });
            }
          }
        } else {
          this.setState({ error: true, errorMessage: 'Failed to add invite members.' });
        }
     
      
      // rcfro2+104@gmail.com
     
    });
  }

  navigateToOfficeMates = () => {
    this.props.history.push('/home/users');
  }

  toggleRoleInfo = () => {
    this.setState({ toggleRoleOpen: !this.state.toggleRoleOpen });
  }


  // shouldComponentUpdate(nextProps, nextState) {
  //   if (this.props.error !== nextProps.error) {
  //     console.log(this.props)
  //     // this.showErrorMsg(this.props.error.response)
  //   }
  //   return false;
  // }

  render() {
    let { error, errorMessage, successMessage, success} = this.state;
    let {user}=this.props
    let{role}=user
    console.log(this.state)
      

    return (
      <div className="inviteUserContainer">
        <div>
          <Breadcrumb>
            <BreadcrumbItem>
              <a className="officemates-link" onClick={this.navigateToOfficeMates}>
                Users
              </a>
            </BreadcrumbItem>
            <BreadcrumbItem active>
              <span className="invite-officemate-name-breadcrumb">
              Invite Others to this Workspace 
              </span>
            </BreadcrumbItem>
          </Breadcrumb>
        </div>
        <div className="invite-officemates-title">Invite Others to this Workspace </div>
        <div className="invite-officemate-hrLine mt10"></div>
        <div className="text-primary-color setup-content mt20">
          {/* To invite others, please provide their login information below and select a role for each one, as a user or an admin. You can always change role or remove them as needed. */}
       
              <div className="text-primary-color setup-content mb40">
              Invite your officemates to the platform by inputting their login information below and assigning them
              roles.{role==='Member'? <span> As a Member, you can invite other Admins, Users, and other Members. </span>:
              role==='User'? <span> As a User, you can invite Admins, others Users, Members. </span>: <span> As an Admin, you can invite other Admins, Users or Members. </span>}
              <span> For more info on roles and privileges, click here 
                <span id="toggleRoleOpen-popover" className="mlRBACInfo" onClick={()=>this.toggleRoleInfo()}><Tooltip /></span>.
                  <Popover placement="right" isOpen={this.state.toggleRoleOpen} target="toggleRoleOpen-popover" toggle={()=>this.toggleRoleInfo()}>
                    <PopoverHeader className="popover-header-tooltip">
                      Roles and Privileges
                    </PopoverHeader>
                    <PopoverBody className="popover-body-tooltip">
                      {roleOptions.map( (e, idx)=>{
                        return <p key={idx}>{e.label}: {e.definition} </p>
                      })}
                      
                    </PopoverBody>
                  </Popover> 
                </span>
            </div>

        </div>
        { success ?
          <Alert color="success">
            {successMessage}
          </Alert>
        :
        null
        }
        {
          error ?
          
          <div className="mt20"><ErrorMessage message={errorMessage} /></div>
          : 
          
          null
        }
        <div className="row mt40">
          <div className="col">
            <Label for="role" className="field-lable" style={{ float: 'left' }}>Role</Label>
          </div>
          <div className="col">
            <Label for="email" className="field-lable" style={{ float: 'left' }}>Email</Label>
          </div>
          <div className="col">
            <Label for="firstName" className="field-lable" style={{ float: 'left' }}>First Name
                <span className="optional-text" style={{ fontSize: '16px', lineHeight: '22px' }}> (Optional)</span></Label>
          </div>
          <div className="col">
            <Label for="lastName" className="field-lable" style={{ float: 'left' }}>Last Name
                <span className="optional-text" style={{ fontSize: '16px', lineHeight: '22px' }}> (Optional)</span></Label>
          </div>
        </div>
        {
          this.populateAddMemberInputs()
        }
        <div className="row" style={{ marginTop: 20 }}>
          <div className="col cursor-pointer" onClick={this.handleAddMember}>
            <img style={{ marginRight: '10px' }} src={addIcon} height="25px" width="25px" />
            <a className="add-officemate-link">Add another</a>
          </div>
        </div>
        <div className="row mb10">
          <div className="col">
            <Button color="primary"
              onClick={this.handleSendInvite}
              className="btn-continue">
              Send Invites
                </Button>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => {
	return {
    toolDetails : state.toolkit.toolDetails,
    user: state.user.profile
	}
}


export default connect(mapStateToProps)(Loading(InviteOfficeMates, axios));
